const BASE_URL = 'https://api.widnex.com/v1/'
const SOCKET_URL = 'https://api.widnex.com/'

export { BASE_URL, SOCKET_URL }
